import React from 'react'
import { Mutation, Query } from 'react-apollo'
import { gql } from 'apollo-boost'
import { Field, Formik } from 'formik'
import * as yup from 'yup'

import TextField from '../TextField'
import ManufacturerSelect from '../Manufacturers/Select'
import Text from '../Text'
import Button from '../Button'
import Loading from '../Loading'
import Form, { Group, Heading } from '../Form'

const GET_MODEL = gql`
  query model($id: ID!) {
    model(id: $id)
    {
      id
      name
      manufacturerName
      manufacturer {
        id
        name
      }
    }
  }
`

const UPDATE_MODEL = gql`
  mutation updateModel(
  $id: ID!
  $name: String!
  $manufacturerName: String!
  $manufacturer: ID!
  ) {
    updateModel(
      id: $id
      name: $name
      manufacturerName: $manufacturerName
      manufacturer: $manufacturer)
    {
      id
      name
      manufacturer {
        id
        name
      }
    }
  }
`

const validationSchema = yup.object().shape({
  id: yup.string().required('ID is required'),
  name: yup.string().required('Our name is required'),
  manufacturerName: yup.string().required('Manufacturer name is required'),
  model: yup.string()
})

const onSubmit = (values, {setSubmitting}, updateModel) => {
  updateModel({variables: values})
  setSubmitting(false)
}

const Update = ({id, onCompleted, onError}) =>
  <Query
    query={GET_MODEL}
    variables={{id}}
    fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (loading) return <Loading />
      if (error) return <Text error>{error.message}</Text>
      if (!data.model) return <Text>Nothing was found!</Text>

      return (
        <Mutation
          mutation={UPDATE_MODEL}
          onCompleted={onCompleted}
          onError={onError}>
          {(updateModel, {loading}) =>
            <Formik
              initialValues={{
                id: data.model.id || '',
                name: data.model.name || '',
                manufacturerName: data.model.manufacturerName || '',
                manufacturer: (data.model.manufacturer && data.model.manufacturer.id) || ''
              }}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => onSubmit(values, actions, updateModel)}>
              {({isSubmitting, values}) =>
                <Form>
                  <Text h2 secondary mb={3}>{values.name}</Text>

                  <Heading>General</Heading>
                  <Group>
                    <Field component={TextField} name='manufacturerName' label='What does the manufacturer call it?' />
                    <Field component={ManufacturerSelect} name='manufacturer' placeholder='Select a manufacturer...' />
                  </Group>
                  <Button type='submit' fluid disabled={loading || isSubmitting}>Save</Button>
                </Form>
              }
            </Formik>
          }
        </Mutation>
      )
    }}
  </Query>

export default Update


// WEBPACK FOOTER //
// ./src/components/Models/Update.js